<template>
  <div class="g-wp w1200">
    <div class="navigation-bar">
      <div>
        <!-- <ul :class="ulClassName">
          <span>分类：</span>
          <li v-for="(item,index) in classify" :key="index" :class="item.className" @click="onLi(index,'classify')">{{item.name}}</li>
        </ul> -->
        <ul :class="[ classifyChild.length > 0 ? 'ul-head' : '' ]">
          <span>分类：</span>
          <li v-for="( item, index ) in classify" :key="index" :class="[ currentClassifyId === item.tagId ? 'onLi' : 'liBorder' ]" @click="hancleClickMenu( index, 'classify', item )">{{ item.valueTag }}</li>
        </ul>
        <ul v-if="classifyChild.length > 0">
          <span></span>
          <li v-for="( item, index ) in classifyChild" :key="index" :class="[ currentClassifyChildId === item.tagId ? 'onLi' : 'classifyChild' ]" @click="hancleClickMenu( index, 'classifyChild',item )">{{ item.valueTag }}</li>
        </ul>
      </div>
      <!-- TODO：暂不支持 -->
      <!-- <ul class="ul-Foot">
        <span>排序：</span>
        <li v-for="(item,index) in liFootList" :key="index" :class="item.className" @click="onLi(index,'liFootList')">{{item.name}}</li>
        <div class="pageIndex">
          <span @click="nextPage('up')">
            <i class="el-icon-arrow-left"></i>
          </span>
          <span class="s1">{{page}} / {{pageIndex}}</span>
          <span @click="nextPage('down')">
            <i class="el-icon-arrow-right"></i>
          </span>
        </div>
      </ul> -->
    </div>
    <ul class="pdf-list">
      <li v-for="( item, index ) in pdfList" :key="index" @click="toPdfDetail( item )">
        <img :src="item | getFileTypeIcon" alt="">
        <div class="p">
          <p>{{ item.datumName }}</p>
          <p class="p2">
            <span>
              类别：{{ item.displayCategory }}
            </span>
            <span class="s2">
              {{ item.readCountTip }}
            </span>
          </p>
        </div>
      </li>
    </ul>
    <div class="block">
      <el-pagination background :current-page="pagination.page" :layout="pagination.layout" :page-size="pagination.pageSize" :total="pagination.total" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
/* global _ */
/* global $http */

export default {
  name: 'pdfList',
  data() {
    return {
      // 分页
      pagination: {
        // layout: 'total, sizes, prev, pager, next, jumper',
        layout: 'prev, pager, next',
        pageSizes: [10, 20, 50],
        page: 1,
        // pageSize: 16,
        pageSize: 5,
        total: 1
      },
      page: 1,
      pageIndex: 10,
      allType: {
        classify: '',
        liFootList: ''
      },

      classify: [
        {
          name: '全部',
          className: 'onLi'
        },
        {
          name: '专业发展',
          className: 'liBorder'
        },
        {
          name: '生活活动',
          className: 'liBorder'
        },
        {
          name: '运动',
          className: 'liBorder'
        },
        {
          name: '游戏活动',
          className: 'liBorder'
        },
        {
          name: '学习活动',
          className: 'liBorder'
        }
      ],
      currentClassifyId: '',

      classifyChild: [],
      currentClassifyChildId: '',

      liFootList: [
        {
          name: '最多阅读',
          className: 'onLi'
        },
        {
          name: ' 最新',
          className: 'liBorder'
        }
      ],
      pdfList: []
    }
  },
  mounted() {
    this.getClassifyList().then(() => {
      this.getPdefList()
    })
  },
  methods: {
    /**
     * 点击菜单
     *
     * TODO：待排序接口
     */
    hancleClickMenu(index, type, row) {
      if (
        this.currentClassifyId === row.tagId ||
        this.currentClassifyChildId === row.tagId
      ) {
        return
      }

      if (type === 'classify') {
        // 一级目录

        if (
          Array.isArray(this[type][index].children) &&
          this[type][index].children.length > 0
        ) {
          this.classifyChild = this[type][index].children || []
        } else {
          this.classifyChild = []
        }

        this.currentClassifyId = row.tagId

        // 没有二级目录
        if (this.classifyChild.length === 0) {
          this.$router.replace({
            path: `?secondCategoryId=${this.currentClassifyId}`
          })
          this.currentClassifyChildId = ''
          this.getPdefList()
        }
      } else if (type === 'classifyChild') {
        // 二级目录

        this.currentClassifyChildId = row.tagId
        this.$router.replace({
          path: `?secondCategoryId=${this.currentClassifyId}&thirdCategoryId=${
            this.currentClassifyChildId
          }`
        })
        this.getPdefList()
      }
    },

    /**
     * 获取菜单目录
     */
    getClassifyList() {
      return $http
        .post('/yswx/gw/videoCourse/getClassList')
        .then(data => {
          // 一级菜单
          this.classify = data.result.list || []

          if (
            this.currentClassifyId === '' &&
            this.currentClassifyChildId === ''
          ) {
            /* 初次进入 */

            this.classifyChild = _.get(this, 'classify[0].children') || []

            this.currentClassifyId = _.get(this, 'classify[0].tagId') || ''
            this.currentClassifyChildId = _.get(this, 'classifyChild[0].tagId') || ''
          } else if (
            this.currentClassifyId &&
            this.currentClassifyChildId === ''
          ) {
            /* 只有一级菜单 刷新 */

            this.classifyChild = []
          } else if (this.currentClassifyId && this.currentClassifyChildId) {
            /* 选中 一、二 级菜单, 刷新 */

            let _item = null
            for (let i = 0; i < this.classify.length; i++) {
              _item = this.classify[i]
              if (
                _item.children.some(
                  v => v.tagId === this.currentClassifyChildId
                )
              ) {
                this.classifyChild = _item.children
                break
              }
            }
          }

          return data
        })
        .catch(err => Promise.reject(err))
    },

    /**
     * 获取文件列表
     */
    getPdefList() {
      let _tagId = ''

      if (this.currentClassifyId && this.currentClassifyChildId) {
        _tagId = this.currentClassifyChildId
      } else if (this.currentClassifyId && !this.currentClassifyChildId) {
        _tagId = this.currentClassifyId
      }

      $http
        .post('/yswx/gw/videoCourse/getDatumListForPC', {
          // tagId: '55',
          tagId: _tagId,
          next: '',
          page: this.pagination.page,
          //
          pageSize: this.pagination.pageSize
        })
        .then(data => {
          this.pdfList = data.result.list
          this.pagination.total = data.result.total
        })
    },

    /**
     * 分页器页数改变回调
     */
    handleCurrentChange(val) {
      this.pagination.page = val
      this.getPdefList()
    },

    /**
     * 跳转文稿详情
     */
    toPdfDetail(row) {
      const routeUrl = this.$router.resolve({
        path: '/pdfDetail',
        query: {
          datumId: row.datumId,
          src: _.get(row, 'url[0].uri') || ''
        }
      })
      window.open(routeUrl.href, '_blank')
    },
    onLi(index, type) {
      this.allType[type] = this[type][index].name
      for (let i = 0; i < this[type].length; i++) {
        this[type][i].className = 'liBorder'
        if (i === index) {
          this[type][i].className = 'onLi'
        }
      }
      this.getPdefList()
    },
    toPage(val) {
      this.page = val
      this.getPdefList()
    },
    nextPage(type) {
      if (type == 'up') {
        this.page--
      } else {
        this.page++
      }
      if (this.page > this.pageIndex) {
        this.page = this.pageIndex
      } else if (this.page < 1) {
        this.page = 1
      } else {
        this.getPdefList()
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>